import React, { createClass, PropTypes } from 'react';
import getClassNames from 'classnames';
import { findDOMNode } from 'react-dom';
import { RaisedButton, Dialog, FlatButton } from 'material-ui';
import {
  and,
  compose,
  all,
  ifElse,
  equals,
  always,
  complement,
  flip,
  either,
  isNil,
  isEmpty,
  props,
} from 'ramda';
const exists = complement(either(isNil, isEmpty));
const flipProps = flip(props);

const InputForm = createClass({

  propTypes: {
    onSubmit: PropTypes.func,
    onChange: PropTypes.func,
    className: PropTypes.string,
    children: PropTypes.any,
    name: PropTypes.string,
    sent: PropTypes.bool,
    userType: PropTypes.string,
    onBoardingState: PropTypes.object,
  },

  getInitialState() {
    return {
      disabled: false,
      emailValidationDialog: false,
      validationDialog: false,
    };
  },

  onSubmit(event) {
    const { userType, onBoardingState } = this.props;
    const checkIfMultiSelectsValid = compose(
      all(exists),
      flipProps(onBoardingState),
      ifElse(
        equals('Supplier'),
          always(['companyTypes', 'marketSegments']),
        always(['companyTypes', 'marketSegments', 'countriesServed'])
      )
    );
    const isValid = and(
      findDOMNode(this.refs.form).checkValidity(),
      checkIfMultiSelectsValid(userType)
    );
    if (isValid) {
      this.props.onSubmit(event);
      this.setState({ sent: true });
    } else {
      event.preventDefault();
      this.setState({ disabled: true }, () => {
        if (!document.getElementById('contactEmail').checkValidity()) {
          this.showDialog('emailValidationDialog');
        } else {
          this.showDialog('validationDialog');
        }
      });
    }
  },

  onChange(event) {
    if (this.props.onChange) this.props.onChange(event);
  },

  dismissDialog(dialog) {
    this.setState({ [dialog]: false });
  },

  showDialog(dialog) {
    this.setState({ [dialog]: true });
  },

  render() {
    const dialogActions = [
      <FlatButton
        label="OK"
        onTouchTap={this.dismissDialog.bind(this, 'validationDialog')}
        secondary
      />,
    ];

    const emailDialogActions = [
      <FlatButton
        label="OK"
        onTouchTap={this.dismissDialog.bind(this, 'emailValidationDialog')}
        secondary
      />,
    ];

    let header;
    let submitButton;
    const classes = getClassNames('form-container', this.props.className, {
      'is-disabled-form': this.state.disabled,
    });

    if (this.props.sent) submitButton = <RaisedButton style={{
      margin: 'auto',
      display: 'block',
      width: '25%',
      marginBottom: '3em',
    }} className={'loader'} disableTouchRipple disableFocusRipple primary label="" />;
    else submitButton = <RaisedButton style={{
      margin: 'auto',
      display: 'block',
      width: '25%',
      marginBottom: '3em',
    }} disableTouchRipple type="button" disableFocusRipple primary onClick={this.onSubmit} label="Submit Profile" />;

    if (this.props.name) header = <h4 className="form-header">{this.props.name}</h4>;

    return (
      <div className={classes}>
        {header}
        <form ref="form" onChange={this.onChange} onSubmit={this.onSubmit}>
          {this.props.children}
          {submitButton}
        </form>
        <Dialog
          className="form-dialog"
          title="Missing some required fields."
          ref="validationDialog"
          actions={dialogActions}
          open={this.state.validationDialog}
          onRequestClose={this.dismissDialog.bind(this, 'validationDialog')}
        >
          Please complete the required fields marked in red.
        </Dialog>
        <Dialog
          className="form-dialog"
          title="Please input a valid email."
          ref="emailValidationDialog"
          actions={emailDialogActions}
          open={this.state.emailValidationDialog}
          onRequestClose={this.dismissDialog.bind(this, 'emailValidationDialog')}
        >
          Please enter a valid email.
        </Dialog>
      </div>

    );
  },
});

export default InputForm;



// WEBPACK FOOTER //
// ./src/app/components/form.jsx